import { all, put, takeLatest, call } from 'redux-saga/effects'
import { SUCCESS_RESPONSES } from '../constants/serverResponses'
import translatinAdapter from '../helpers/translations'
import { DataDog } from '../datadog'
import { getTransactionDetails } from '../api/payments'
import translatesConfig from '../../../translates.config'
import { config } from '../config'
import { loadScriptAsync, redirect, replaceAll } from '../helpers/common'
import {
  componentsLoadUpdate,
} from '../redux/slice/pageStateSlice'
import { transactionDetailsUpdate } from '../redux/slice/transactionDetailsSlice'

const GET_TRANSACTION_DETAILS =
  'transactionDetails/transactionDetailsUpdateAction'

export const loadTranslations = async tenantId => {
  if (!translatesConfig.tenants.includes(tenantId)) return
  const url = `${config.baseURL}${tenantId}-translations-opp.js`
  return loadScriptAsync(url)
}

export const prepareTranslations = tenantId =>
  Object.keys(window.tuiPaymentTranslations?.default).reduce((acc, el) => {
    acc[el] = {
      ...window.tuiPaymentTranslations?.default[el],
      ...window.tuiPaymentTranslations?.[tenantId][el],
    }
    return acc
  }, {})

export function* getTransactionDetailsSaga(data) {
  const { setDetailsError } = data.payload
  try {
    const response = yield call(getTransactionDetails)
    const { responseData, responseStatus } = response

    if (responseStatus === SUCCESS_RESPONSES.OK) {
      window.tuiPaymentsMFEInstance.getInitialiseData = () => responseData

      responseData.culture = replaceAll(responseData.culture, '_', '-')

      if (responseData.countryCode === 'UK') {
        responseData.countryCode = 'GB'
      }

      if (responseData?.billingAddress?.country === 'UK') {
        responseData.billingAddress.country = 'GB'
      }

      yield call(loadTranslations, responseData.tenantId)
      const translations = window.tuiPaymentTranslations?.[
        responseData.tenantId
      ]
        ? prepareTranslations(responseData.tenantId)
        : window.tuiPaymentTranslations?.default

      const culture = translations[responseData.culture?.toLowerCase()]
        ? responseData.culture
        : 'en-gb'

      translatinAdapter.setTranslations(translations, culture)

      // Need to override transaction details data here instead of adding additional hooks. @see OPP-1811
      yield put(
        transactionDetailsUpdate({
          ...responseData,
          userEmail: responseData?.billingAddress?.email,
          culture,
          initCulture: responseData?.culture?.toLowerCase(),
        }),
      )

      // A valid payment-method configuration has now been stored. This is
      // distinct from isConfigReady (set in `finally` for every outcome).
      yield put(
        componentsLoadUpdate({
          isConfigLoaded: true,
        }),
      )

      DataDog.info('Set transactionId for logging', {
        transactionId: responseData?.id,
      })
      DataDog.setTenantId(responseData?.tenantId)
      DataDog.setTransactionId(responseData?.id)
      DataDog.info('Transaction values are added to log scopes.')
    } else {
      if (responseData?.redirectUrl) {
        return redirect(responseData.redirectUrl)
      }
      setDetailsError(true)
    }
  } catch (e) {
    setDetailsError(true)
  } finally {
    yield put(
      componentsLoadUpdate({
        isConfigReady: true,
      }),
    )
  }
}

export default function* () {
  yield all([takeLatest(GET_TRANSACTION_DETAILS, getTransactionDetailsSaga)])
}
